import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmInfoCircle } from '@websolutespa/bom-mixer-icons';
import { marked } from 'marked';
import { useMemo } from 'react';
import { useLlm } from '../../../useLlm/useLlm';

type LlmTextProps = {
  body: string;
  disclaimer?: boolean;
};

export const Text = (props: LlmTextProps) => {
  const label = useLabel();
  const app = useLlm(state => state.app);
  const appDisclaimer = app?.contents.disclaimer;
  const html = useMemo(() => {
    marked.use({
      renderer: {
        link(href: string, title: string | null | undefined, text: string) {
          return `<a class="llm__text-link" href="${href}" target="_blank"
          ${title ? `title="${title}"` : ''}
          onclick="javascript:event.preventDefault(),window.open(event.currentTarget.href);">
            ${text}
          </a>`;
        },
        image(href: string, title: string | null | undefined, text: string) {
          return `<a class="llm__text-img" href="${href}" target="_blank"
          onclick="javascript:event.preventDefault(),window.open(event.currentTarget.href);">
            <img src="${href}"${title ? ` title="${title}"` : ''} alt="${text}" />
          </a>`;
        },
      }
    });
    return marked.parse(props.body);
  }, [props.body]);
  const disclaimer = props.disclaimer ? (appDisclaimer || label('llm.disclaimer')) : '';
  return (
    <div className="llm__text">
      <div className="llm__text-body" dangerouslySetInnerHTML={{ __html: html }} />
      {disclaimer && (
        <small className="llm__text-disclaimer">
          <i><IconLlmInfoCircle /></i>
          <div dangerouslySetInnerHTML={{ __html: disclaimer }} />
        </small>
      )}
    </div>
  );
};
